<script>
	import CaseStudy from '$lib/Components/CaseStudy/CaseStudy.svelte';
	import Grid from '$lib/Components/Layout/Grid/Grid.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';

	import acoustic from './images/acoustic-grade.jpg';
	import commercial from './images/commercial-grade.jpg';
	import museum from './images/museum-grade.jpg';
	import privacy from './images/privacy-grade.jpg';
	import sleep from './images/sleep-panels.jpg';
	import standard from './images/standard-grade.jpg';
</script>

<Section backgroundColor="white">
	<p>
		When your windows aren't working as well as you'd like, don't shell out big
		bucks to replace them. With custom storm window inserts, you can preserve
		their integrity while also boosting their utility, efficiency and value. At
		Indow, we offer six distinct grades of custom window inserts, all of which
		fit tightly into your existing window frames to block drafts and reduce
		outside noise.
	</p>
	<p>
		Each interior window insert grade is made from durable, continuously
		manufactured acrylic with its own special superpower — UV protection,
		enhanced soundproofing, privacy and more. Choose the kind that works best
		for you!
	</p>
	<p>
		And don't worry if some of your windows are an <a
			href="/solutions/odd-shaped-window-inserts/">unusual shape</a
		>. Our inserts can be custom-made to fit them perfectly, making storm window
		installation a breeze.
	</p>

	<Grid columns="3" rows="4" center>
		<Grid subgrid vertical>
			<CaseStudy
				title="Standard Grade"
				href="/custom-storm-windows/standard-grade/"
				src={standard}
				alt="Energy efficient interior storm windows."
				description="Standard Grade is our workhorse interior storm window insert. It blocks drafts and reduces outside noise."
				learnMore
				subgrid
			/>
		</Grid>
		<Grid subgrid vertical>
			<CaseStudy
				title="Acoustic Grade"
				href="/custom-storm-windows/acoustic-grade/"
				src={acoustic}
				alt="Acoustic grade storm windows for old homes."
				description="Twice as thick as Standard Grade, Acoustic Grade windows offer the same high quality as Standard Grade, but with superior soundproofing to block noise."
				learnMore
				subgrid
			/>
		</Grid>
		<Grid subgrid vertical>
			<CaseStudy
				title="Museum Grade"
				href="/custom-storm-windows/museum-grade"
				src={museum}
				alt="UV blocking interior storm windows custom fit."
				description="Museum Grade custom storm window inserts provide UV protection for your furniture and artwork, while offering the same clarity as our Standard Grade windows."
				learnMore
				subgrid
			/>
		</Grid>
	</Grid>
	<hr class="hidden md:block" />
	<Grid columns="3" rows="4" center>
		<Grid subgrid vertical>
			<CaseStudy
				title="Privacy Grade"
				href="/custom-storm-windows/privacy-grade"
				src={privacy}
				alt="Custom storm windows for bathroom privacy."
				description="If you're looking for a way to enhance privacy at home, you'll like our Privacy Grade option. Obscure the views of passersby while still enjoying plenty of light."
				learnMore
				subgrid
			/>
		</Grid>
		<Grid subgrid vertical>
			<CaseStudy
				title="Sleep Panels"
				href="/custom-storm-windows/sleep-panel"
				src={sleep}
				alt="Interior storm window with blackout privacy for sleep."
				description="Our Sleep Panels are perfect for blocking light in bedrooms. They eliminate all light for more restful sleep and also can help those with light sensitivity and migraines."
				learnMore
				subgrid
			/>
		</Grid>
		<Grid subgrid vertical>
			<CaseStudy
				title="Commercial Grade"
				href="/custom-storm-windows/commercial-grade"
				src={commercial}
				alt="Commercial storm window for soundproofing."
				description="Our Commercial Grade custom storm window inserts are scratch-resistant, making ideal for commercial settings or busy homes."
				learnMore
				subgrid
			/>
		</Grid>
	</Grid>
</Section>
